<footer class="footer">
    <div class="footer-container">
        <div class="footer-row">
            <!-- Column 1: Logo -->
            <div class="footer-col">
                <div class="footer-logo">
                    <img src="./assets/images/logo-o.png" alt="Farco Security Logo" class="logo-image">
                </div>
            </div>

            <!-- Column 2: Main Links -->
            <div class="footer-col">
                <div class="footer-links">
                    <a href="#" class="footer-link">Accueil</a>
                    <a href="#" class="footer-link">A propos</a>
                    <a href="#" class="footer-link">Services</a>
                    <a href="#" class="footer-link">Conditions</a>
                    <a href="#" class="footer-link">Contact</a>
                </div>
            </div>

            <!-- Column 3: Security Services -->
            <div class="footer-col">
                <div class="footer-links">
                    <a href="#" class="footer-link">Protection de bien mobilier et immobilier</a>
                    <a href="#" class="footer-link">Contrôle des personnes et d'accès</a>
                    <a href="#" class="footer-link">Sécurité événementielle</a>
                    <a href="#" class="footer-link">Gardiennage chantier</a>
                    <a href="#" class="footer-link">Gardiennage industriel</a>
                    <a href="#" class="footer-link">Accueil et gestion</a>
                </div>
            </div>

            <!-- Column 4: Contact Info -->
            <div class="footer-col">
                <div class="contact-info">
                    <div class="contact-item">
                        <span class="contact-label">Adresse :</span>
                        <div class="contact-details">
                            <p>Farco Security<br> Rue J. Vanderick 148 6180 Courcelles</p>
                            <p>BE0687.809.281</p>
                            <p>AM 0687809281</p>
                        </div>
                    </div>

                    <div class="contact-item-inline">
                        <span class="contact-label">Email :</span>
                        <a href="mailto:info@farcosecurity.be" class="contact-detail link">info@farcosecurity.be</a>
                    </div>

                    <div class="contact-item-inline">
                        <span class="contact-label">Numéro :</span>
                        <a href="tel:071686886" class="contact-detail link">071/68 68 86</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>